// import React, { useState } from 'react';
// import { TextField, Button, Container, Box, Typography } from '@mui/material';
// import { styled } from '@mui/system';
// import { ToastContainer } from 'react-toastify';
// import Swal from 'sweetalert2';
// import validate from '../../../common/contactusValidation'; // Import your validation function
// import { ContactusApi } from '../../../../services/api/UserAPI';

// interface FormData {
// 	name: string;
// 	email: string;
// 	contactNo: string;
// 	description: string;
// }

// interface Errors {
// 	name?: string;
// 	email?: string;
// 	contactNo?: string;
// 	description?: string;
// }

// const StyledContainer = styled(Container)({
// 	marginTop: '2rem',
// 	display: 'flex',
// 	flexDirection: 'column',
// 	alignItems: 'center',
// 	border: '1px solid #D9D9D980',
// 	background: '#FFFFFF',
// 	boxShadow: '0px 3px 6px 0px #0000003D',
// 	borderRadius: '20px',
// 	padding: '36px 28px',
// });

// const StyledTextField = styled(TextField)({
// 	marginBottom: '1rem',
// 	width: '100%',
// });

// const ContactUsForm: React.FC = () => {
// 	const [formData, setFormData] = useState<FormData>({
// 		name: '',
// 		email: '',
// 		contactNo: '',
// 		description: '',
// 	});
// 	const [loadingData, selLoadingData] = useState(false);

// 	const [errors, setErrors] = useState<Errors>({});

// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const { name, value } = e.target;
// 		setFormData({
// 			...formData,
// 			[name]: value,
// 		});

// 		// Validate the specific field being changed
// 		const fieldErrors = validate({ ...formData, [name]: value });
// 		if (!fieldErrors[name as keyof FormData]) {
// 			setErrors((prevErrors) => ({
// 				...prevErrors,
// 				[name]: undefined,
// 			}));
// 		}
// 	};

// 	const handleSubmit = (e: React.FormEvent) => {
// 		e.preventDefault();
// 		const validationErrors = validate(formData);
// 		setErrors(validationErrors);

// 		if (Object.keys(validationErrors).length === 0) {
// 			const fetchData = async () => {
// 				const data = {
// 					name: formData.name,
// 					email: formData.email,
// 					mobile: formData.contactNo,
// 					message: formData.description,
// 				};
// 				try {
// 					selLoadingData(true);
// 					const response = await ContactusApi(data);
// 					if (response.success) {
// 						// toast.success(response?.data?.message);
// 						Swal.fire({
// 							icon: 'success',
// 							title: 'Thank you!',
// 							text: `${response?.data?.message}`,
// 							showConfirmButton: true,
// 							customClass: {
// 								popup: 'poppins-font',
// 							},
// 							backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
// 							background: '#fff',
// 						});
// 						setFormData({ name: '', email: '', contactNo: '', description: '' });
// 					}
// 				} catch (error) {
// 					console.log(error);
// 				} finally {
// 					selLoadingData(false);
// 				}

// 				// Form is valid, handle submission
// 				console.log('Form submitted:', formData);
// 			};
// 			fetchData();
// 		}
// 	};

// 	return (
// 		<StyledContainer>
// 			<Box component="form" onSubmit={handleSubmit} noValidate>
// 				<StyledTextField
// 					label="Name"
// 					name="name"
// 					size="small"
// 					color="secondary"
// 					value={formData.name}
// 					onChange={handleChange}
// 					error={!!errors.name}
// 					helperText={errors.name}
// 				/>
// 				<StyledTextField
// 					label="Email"
// 					name="email"
// 					color="secondary"
// 					size="small"
// 					value={formData.email}
// 					onChange={handleChange}
// 					error={!!errors.email}
// 					helperText={errors.email}
// 				/>
// 				<StyledTextField
// 					label="Contact Number"
// 					name="contactNo"
// 					type="number"
// 					size="small"
// 					color="secondary"
// 					value={formData.contactNo}
// 					onChange={handleChange}
// 					error={!!errors.contactNo}
// 					helperText={errors.contactNo}
// 				/>
// 				<StyledTextField
// 					label="Description"
// 					name="description"
// 					color="secondary"
// 					size="small"
// 					value={formData.description}
// 					onChange={handleChange}
// 					error={!!errors.description}
// 					helperText={errors.description}
// 					multiline
// 					rows={4}
// 				/>
// 				{/* Add a date picker component here */}
// 				<Typography textAlign={'center'}>
// 					<Button
// 						sx={{ width: '80%', textAlign: 'center' }}
// 						type="submit"
// 						variant="contained"
// 						color="primary"
// 						loading={loadingData}
// 						loadingIndicator="Sending..."
// 					>
// 						Submit
// 					</Button>
// 				</Typography>
// 			</Box>
// 			<ToastContainer />
// 		</StyledContainer>
// 	);
// };

// export default ContactUsForm;
import React, { useState } from 'react';
import { TextField, Button, Container, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import validate from '../../../common/contactusValidation'; // Import your validation function
import { ContactusApi } from '../../../../services/api/UserAPI';

interface FormData {
	name: string;
	email: string;
	contactNo: string;
	description: string;
	location: string;
}

interface Errors {
	name?: string;
	email?: string;
	contactNo?: string;
	description?: string;
	location?: string;
}

const StyledContainer = styled(Container)({
	marginTop: '2rem',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	border: '1px solid #D9D9D980',
	background: '#FFFFFF',
	boxShadow: '0px 3px 6px 0px #0000003D',
	borderRadius: '20px',
	padding: '36px 28px',
});

const StyledTextField = styled(TextField)({
	marginBottom: '1rem',
	width: '100%',
});

const ContactUsForm: React.FC = () => {
	const [formData, setFormData] = useState<FormData>({
		name: '',
		email: '',
		contactNo: '',
		description: '',
		location: '',
	});
	const [loadingData, selLoadingData] = useState(false);

	const [errors, setErrors] = useState<Errors>({});

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		// Validate the specific field being changed
		const fieldErrors = validate({ ...formData, [name]: value });
		if (!fieldErrors[name as keyof FormData]) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[name]: undefined,
			}));
		}
	};

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const validationErrors = validate(formData);
		setErrors(validationErrors);

		if (Object.keys(validationErrors).length === 0) {
			const fetchData = async () => {
				const data = {
					name: formData.name,
					email: formData.email,
					mobile: formData.contactNo,
					message: formData.description,
					location: formData.location,
					source: 'Website',
				};
				try {
					selLoadingData(true);
					const response = await ContactusApi(data);
					if (response.success) {
						// toast.success(response?.data?.message);
						Swal.fire({
							icon: 'success',
							title: 'Thank you!',
							text: `${response?.data?.message}`,
							showConfirmButton: true,
							customClass: {
								popup: 'poppins-font',
							},
							backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
							background: '#fff',
						});
						setFormData({
							name: '',
							email: '',
							contactNo: '',
							description: '',
							location: '',
						});
					}
				} catch (error) {
					console.log(error);
				} finally {
					selLoadingData(false);
				}

				// Form is valid, handle submission
				console.log('Form submitted:', formData);
			};
			fetchData();
		}
	};

	return (
		<StyledContainer>
			<Box component="form" onSubmit={handleSubmit} noValidate>
				<StyledTextField
					label="Name"
					name="name"
					size="small"
					color="secondary"
					value={formData.name}
					onChange={handleChange}
					error={!!errors.name}
					helperText={errors.name}
				/>
				<StyledTextField
					label="Email"
					name="email"
					color="secondary"
					size="small"
					value={formData.email}
					onChange={handleChange}
					error={!!errors.email}
					helperText={errors.email}
				/>
				<StyledTextField
					label="Whatsapp Number"
					name="contactNo"
					type="number"
					size="small"
					color="secondary"
					value={formData.contactNo}
					onChange={handleChange}
					error={!!errors.contactNo}
					helperText={errors.contactNo}
				/>
				<StyledTextField
					label="Location"
					name="location"
					type="text"
					size="small"
					color="secondary"
					value={formData.location}
					onChange={handleChange}
					error={!!errors.location}
					helperText={errors.location}
				/>
				<StyledTextField
					label="Description"
					name="description"
					color="secondary"
					size="small"
					value={formData.description}
					onChange={handleChange}
					error={!!errors.description}
					helperText={errors.description}
					multiline
					rows={4}
				/>
				{/* Add a date picker component here */}
				<Typography textAlign={'center'}>
					<Button
						sx={{ width: '80%', textAlign: 'center' }}
						type="submit"
						variant="contained"
						color="primary"
						loading={loadingData}
						loadingIndicator="Sending..."
					>
						Submit
					</Button>
				</Typography>
			</Box>
			<ToastContainer />
		</StyledContainer>
	);
};

export default ContactUsForm;
